import { unitMapping } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  size?: keyof typeof unitMapping;
  title?: string;
  titleId?: string;
  color?: Color;
  className?: string;
  action?: 'vault' | 'unvault' | 'unselect';
};

export const Vault = ({
  size = 2,
  title,
  titleId,
  color = 'currentColor',
  className,
  action,
}: Props) => {
  const fill = color || 'currentColor';

  return (
    <svg
      viewBox="0 0 16 16"
      style={{ height: unitMapping[size] }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H5.89474V2.52632H2.52632V5.89474H0V0ZM10.1053 0H16V5.89474H13.4737V2.52632H10.1053V0ZM2.52632 10.1053V13.4737H5.89474V16H0V10.1053H2.52632ZM16 10.1053V16H10.1053V13.4737H13.4737V10.1053H16Z"
        fill={fill}
      />
      {action === 'vault' && (
        <path d="M9 4.5H7V7L4.5 7V9H7V11.5H9V9H11.5V7L9 7V4.5Z" fill={fill} />
      )}
      {action === 'unvault' && (
        <path d="M4.5 7V9L11.5 9V7L4.5 7Z" fill={fill} />
      )}
      {action === 'unselect' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7072 6.20718L7.00008 10.9143L4.29297 8.20718L5.70718 6.79297L7.00008 8.08586L10.293 4.79297L11.7072 6.20718Z"
          fill={fill}
        />
      )}
    </svg>
  );
};
